import React, { useEffect, useState } from "react";
import SabhaSaarLogo from "../assets/images/SabhaSaarLogo.png";
import Emblem from "../assets/images/emblem.png";
import PanchayatiRajLogo from "../assets/images/PanchayatiRajLogo.png";
import Wrapper from "../assets/wrappers/SabhaSaarHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectIsAuthenticated, logout } from "../features/authSlice";
import { RootState } from "../store";

const SabhaSaarHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isDirty } = useSelector((state: RootState) => state.upload);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [loggedIn, setIsLoggedIn] = useState(false);
  const { portal, meetingDetailsNirnany } = useSelector((state: RootState) => state.auth);

  // const handleLogout = () => {
  //   dispatch(logout());
  //   setIsLoggedIn(false);
  //   navigate("/");
  // };

  const handleLogout = () => {
    const currentPath = location.pathname;

    const shouldShowConfirm =
      (currentPath === "/processing" || currentPath.startsWith("/draft-meeting/")) && !isDirty;

    if (shouldShowConfirm) {
      const confirmed = window.confirm(
        "You have unsubmitted changes in your SabhaSaar MoM data. Are you sure you want to leave?"
      );

      if (!confirmed) return;
    }

    dispatch(logout());
    setIsLoggedIn(false);
    navigate("/");
  };

  useEffect(() => {
    const tokenExists = !!localStorage.getItem("loginDetails");
    if (location.pathname === "/") {
      localStorage.removeItem("loginDetails");
      dispatch(logout());
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(isAuthenticated || tokenExists);
    }
  }, [location.pathname]);

  const handleHeaderClick = () => {
    if (loggedIn) {
      navigate("/afterLogin");
    } else {
      navigate("/");
    }
  };

  return (
    <Wrapper>
      <div className="sabhaSaar-header">
        <div
          className="sabhaSaar-header-left"
          onClick={handleHeaderClick}
          style={{ cursor: "pointer" }}
        >
          <img src={Emblem} alt="Emblem_India" />
          <div className="bhashini-skip-translation">
            <h4>Ministry of Panchayati Raj</h4>
            <span>पंचायती राज मंत्रालय</span>
          </div>
        </div>
        <div
          className="sabhaSaar-header-right"
          onClick={handleHeaderClick}
          style={{ cursor: "pointer" }}
        >
          <img src={SabhaSaarLogo} alt="SabhaSaarLogo" />
          <div>
            {/* <h4>SabhaSaar</h4> */}
            <span>"हर चर्चा का सार, सभासार"</span>
          </div>
          {loggedIn && (
            <div className="mx-3">
              {portal !== "N" &&
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLogout();
                  }}
                  className="btn btn-blue-small"
                  role="button"
                >
                  Logout
                </button>
              }
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default SabhaSaarHeader;
